import FieldHeader from '@wds/blocks/common/FieldHeader/FieldHeader';
import SubscriptionPopup from './SubscriptionPopup';
import ErrorBoundary from '@wds/blocks/common/ErrorBoundary';
import { SUBSCRIPTIONS_STORE_NAME as STORE_NAME } from '../../constants';
import { useSelect } from '@wordpress/data';
import useFetchSubscriptionDataOnShippingMethodChange from '../../hooks/useFetchSubscriptionDataOnShippingMethodChange';
import SubscriptionProductType from '../../valueObject/SubscriptionProductType';
import { getSelectedShippingMethod, getSelectedShippingMethodForSubscription } from '../../common/helper';
import { isDeliverySlotsEnabledForShippingMethod } from '../subscriptionHelper';

const SubscriptionContainer = () => {
    const subscriptionProducts = useSelect(select => select(STORE_NAME).getProducts('subscription'));
    const regularProducts = useSelect(select => select(STORE_NAME).getProducts('regular'));
    const conflictMessage = useSelect(select => select(STORE_NAME).getConflictMessage());
    const areSlotsAllowed = useSelect(select => select(STORE_NAME).getAreSlotsAllowed());

    const subscriptionShippingMethod = getSelectedShippingMethodForSubscription();
    const regularShippingMethod = getSelectedShippingMethod(0);

    const isSubscriptionShippingMethodEnabled = isDeliverySlotsEnabledForShippingMethod(subscriptionShippingMethod);
    const isRegularShippingMethodEnabled = isDeliverySlotsEnabledForShippingMethod(regularShippingMethod);

    // Handle shipping method changes, fetch the bookable dates, reserved slots, etc.
    useFetchSubscriptionDataOnShippingMethodChange();

    if ( !subscriptionProducts ) {
        return <>
            {/* Represents the loading state of the subscription fields. This means the WDS data hasn't been loaded yet. */}
            <input type="hidden" name="iconic-wds-subscription-loading" value="1" />
        </>
    }

    // If both shipping methods are disabled, don't render the container.
    if ( !isSubscriptionShippingMethodEnabled && !(isRegularShippingMethodEnabled && regularProducts) ) {
        return null;
    }

    if ( conflictMessage || !areSlotsAllowed ) {
        return null;
    }

    return (
        <div className="wds-fieldbox">
            <ErrorBoundary>
                <FieldHeader />
                <div className="wds-fieldbox__fields">
                    { isSubscriptionShippingMethodEnabled && <SubscriptionPopup type={SubscriptionProductType.SUBSCRIPTION} /> }
                    { isRegularShippingMethodEnabled && regularProducts && <SubscriptionPopup type={SubscriptionProductType.REGULAR} /> }
                </div>
            </ErrorBoundary>
        </div>
    );
};

export default SubscriptionContainer; 